// Holographic Die-Cut Sticker Customizer - Core JavaScript
// Border: animated holographic shimmer along design contour
// White/light pixel overlay: holographic shimmer on light areas
// Export: transparent PNG — design only, cut to shape

(function() {
  'use strict';

  const state = {
    uploadedImage: null,
    uploadedImageUrl: null,
    cloudinaryUrl: null,
    canvas: null,
    ctx: null,
    canvasSize: 450,
    imagePosition: { x: 225, y: 225 },
    imageScale: 1,
    imageRotation: 0,
    brightness: 100,
    contrast: 100,
    saturation: 100,
    flipHorizontal: false,
    flipVertical: false,
    selectedElement: null,
    dragOffset: { x: 0, y: 0 },
    isDragging: false,
    isResizing: false,
    initialSize: 0,
    initialDistance: 0,
    imageLayer: 1,
    backgroundRemoved: false,
    requestManualPreview: false,
    productData: {
      quantity: '',
      size: '',
      price: '',
      title: '',
      variantId: ''
    },
    exportCanvas: null,
    exportCtx: null,
    holoHue: 0,
    holoShine: 0,
    animationFrame: null
  };

  document.addEventListener('DOMContentLoaded', function() {
    initializeCustomizer();
  });

  function initializeCustomizer() {
    state.canvas = document.getElementById('designCanvas');
    if (!state.canvas) { console.error('Canvas not found'); return; }
    state.ctx = state.canvas.getContext('2d');

    state.exportCanvas = document.createElement('canvas');
    state.exportCanvas.width = 1800;
    state.exportCanvas.height = 1800;
    state.exportCtx = state.exportCanvas.getContext('2d');

    loadProductData();
    alignSliders();
    setupTabNavigation();
    setupUpload();
    setupImageControls();
    setupPreviewCheckbox();
    setupSaveButton();
    setupResetButton();
    setupKeyboardControls();

    startHoloAnimation();
  }

  // ============================================
  // HOLOGRAPHIC ANIMATION
  // ============================================

  function startHoloAnimation() {
    function animate() {
      state.holoHue   = (state.holoHue   + 0.5) % 360;
      state.holoShine = (state.holoShine + 1.2) % 500;
      renderCanvas();
      state.animationFrame = requestAnimationFrame(animate);
    }
    state.animationFrame = requestAnimationFrame(animate);
  }

  function createHoloPattern(width, height) {
    const patCanvas = document.createElement('canvas');
    patCanvas.width  = width;
    patCanvas.height = height;
    const patCtx = patCanvas.getContext('2d');

    patCtx.fillStyle = 'rgb(220, 220, 225)';
    patCtx.fillRect(0, 0, width, height);

    const grad = patCtx.createLinearGradient(0, 0, width, height);
    const hue = state.holoHue;
    grad.addColorStop(0,    `hsla(${hue}, 55%, 75%, 0.7)`);
    grad.addColorStop(0.25, `hsla(${(hue + 60)  % 360}, 50%, 78%, 0.7)`);
    grad.addColorStop(0.5,  `hsla(${(hue + 150) % 360}, 55%, 80%, 0.7)`);
    grad.addColorStop(0.75, `hsla(${(hue + 220) % 360}, 50%, 78%, 0.7)`);
    grad.addColorStop(1,    `hsla(${hue}, 55%, 75%, 0.7)`);
    patCtx.fillStyle = grad;
    patCtx.fillRect(0, 0, width, height);

    const shineX = state.holoShine - 50;
    const shineGrad = patCtx.createLinearGradient(shineX - 60, 0, shineX + 60, height);
    shineGrad.addColorStop(0,    'rgba(255,255,255,0)');
    shineGrad.addColorStop(0.45, 'rgba(255,255,255,0)');
    shineGrad.addColorStop(0.5,  'rgba(255,255,255,0.25)');
    shineGrad.addColorStop(0.55, 'rgba(255,255,255,0)');
    shineGrad.addColorStop(1,    'rgba(255,255,255,0)');
    patCtx.fillStyle = shineGrad;
    patCtx.fillRect(0, 0, width, height);

    return patCanvas;
  }

  // ============================================
  // PRODUCT DATA
  // ============================================

  function loadProductData() {
    const urlParams = new URLSearchParams(window.location.search);
    state.productData.quantity  = urlParams.get('quantity') || '';
    state.productData.size      = urlParams.get('size')     || '';
    state.productData.price     = urlParams.get('price')    || '';
    state.productData.title     = urlParams.get('title')    || 'Die-Cut Holographic Stickers';
    state.productData.variantId = urlParams.get('variant')  || '';

    if (!state.productData.variantId) tryToFindVariant();

    const productInfo = document.getElementById('productInfo');
    if (productInfo && state.productData.quantity && state.productData.size && state.productData.price) {
      productInfo.textContent = `${state.productData.quantity} ${state.productData.title} \u2022 ${state.productData.size}" \u2022 $${state.productData.price}`;
    } else if (productInfo) {
      productInfo.textContent = 'Holographic Die-Cut Sticker Customizer';
    }
  }

  function tryToFindVariant() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('select[name="id"], input[name="id"]');
      if (variantInput && variantInput.value) { state.productData.variantId = variantInput.value; return; }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('return_url');
    if (returnUrl) {
      const match = returnUrl.match(/variant=(\d+)/);
      if (match && match[1]) { state.productData.variantId = match[1]; return; }
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      state.productData.variantId = window.ShopifyAnalytics.meta.selectedVariantId;
    }
  }

  function setupKeyboardControls() {
    document.addEventListener('keydown', function(e) {
      if ((e.key === 'Delete' || e.key === 'Backspace') && state.selectedElement) {
        e.preventDefault();
        deleteSelectedElement();
      }
    });
  }

  function alignSliders() {
    const b = document.getElementById('brightnessSlider');
    const c = document.getElementById('contrastSlider');
    const s = document.getElementById('saturationSlider');
    if (b) { b.min = 50; b.max = 150; b.value = 100; }
    if (c) { c.min = 50; c.max = 150; c.value = 100; }
    if (s) { s.min = 0;  s.max = 200; s.value = 100; }
  }

  function setupTabNavigation() {
    const sidebarIcons = document.querySelectorAll('.sidebar-icon');
    sidebarIcons.forEach(icon => {
      icon.addEventListener('click', function() {
        const tab = this.getAttribute('data-tab');
        sidebarIcons.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
        document.querySelectorAll('.panel-content').forEach(p => p.classList.remove('active'));
        const targetPanel = document.querySelector(`[data-content="${tab}"]`);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

  // ============================================
  // UPLOAD
  // ============================================

  function setupUpload() {
    const uploadArea = document.getElementById('uploadArea');
    const fileInput  = document.getElementById('fileInput');
    const removeBtn  = document.getElementById('removeImageBtn');

    if (uploadArea && fileInput) {
      uploadArea.addEventListener('click', () => { fileInput.value = ''; fileInput.click(); });
      fileInput.addEventListener('change', function(e) {
        if (e.target.files && e.target.files[0]) handleFileUpload(e.target.files[0]);
      });
      uploadArea.addEventListener('dragover',  function(e) { e.preventDefault(); this.classList.add('dragging'); });
      uploadArea.addEventListener('dragleave', function(e) { e.preventDefault(); this.classList.remove('dragging'); });
      uploadArea.addEventListener('drop', function(e) {
        e.preventDefault(); this.classList.remove('dragging');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) handleFileUpload(e.dataTransfer.files[0]);
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        resetImageState();
        document.getElementById('uploadedImageInfo').style.display = 'none';
        const fi = document.getElementById('fileInput');
        if (fi) fi.value = '';
        resetAdjustmentSliders();
        showMessage('Image removed', 'success');
      });
    }
  }

  function resetImageState() {
    state.uploadedImage     = null;
    state.uploadedImageUrl  = null;
    state.cloudinaryUrl     = null;
    state.selectedElement   = null;
    state.imageScale        = 1;
    state.imageLayer        = 1;
    state.imagePosition     = { x: 225, y: 225 };
    state.imageRotation     = 0;
    state.brightness        = 100;
    state.contrast          = 100;
    state.saturation        = 100;
    state.flipHorizontal    = false;
    state.flipVertical      = false;
    state.backgroundRemoved = false;
  }

  function resetAdjustmentSliders() {
    [['brightnessSlider','brightnessValue'],['contrastSlider','contrastValue'],['saturationSlider','saturationValue']].forEach(function(pair) {
      var slider = document.getElementById(pair[0]);
      var display = document.getElementById(pair[1]);
      if (slider) slider.value = 100;
      if (display) display.textContent = '100%';
    });
  }

  function handleFileUpload(file) {
    if (!file.type.match('image.*')) { showMessage('Please upload an image file', 'error'); return; }
    if (file.size > 50 * 1024 * 1024) { showMessage('File size must be under 50MB', 'error'); return; }
    showMessage('Uploading image...', 'info');
    uploadToCloudinary(file);
  }

  function uploadToCloudinary(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
    formData.append('folder', window.cloudinaryConfig.folder);
    fetch('https://api.cloudinary.com/v1_1/' + window.cloudinaryConfig.cloudName + '/image/upload', {
      method: 'POST', body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.secure_url) {
        state.cloudinaryUrl = data.secure_url;
        loadImageToCanvas(data.secure_url);
        document.getElementById('uploadedImageInfo').style.display = 'block';
        document.getElementById('imageFileName').textContent = file.name;
        showMessage('Image uploaded successfully!', 'success');
      } else {
        showMessage('Upload failed. Please try again.', 'error');
      }
    })
    .catch(function() { showMessage('Upload failed. Please try again.', 'error'); });
  }

  function loadImageToCanvas(url) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      state.uploadedImage    = img;
      state.uploadedImageUrl = url;
      state.imagePosition    = { x: 225, y: 225 };
      const maxSize = state.canvasSize * 0.85;
      state.imageScale = maxSize / Math.max(img.width, img.height);
      state.imageLayer = 1;
    };
    img.src = url;
  }

  // ============================================
  // IMAGE CONTROLS
  // ============================================

  function setupImageControls() {
    var bSlider = document.getElementById('brightnessSlider');
    var bValue  = document.getElementById('brightnessValue');
    var cSlider = document.getElementById('contrastSlider');
    var cValue  = document.getElementById('contrastValue');
    var sSlider = document.getElementById('saturationSlider');
    var sValue  = document.getElementById('saturationValue');

    if (bSlider && bValue) bSlider.addEventListener('input', function() { state.brightness = this.value; bValue.textContent = this.value + '%'; });
    if (cSlider && cValue) cSlider.addEventListener('input', function() { state.contrast   = this.value; cValue.textContent = this.value + '%'; });
    if (sSlider && sValue) sSlider.addEventListener('input', function() { state.saturation = this.value; sValue.textContent = this.value + '%'; });

    var removeBackgroundBtn = document.getElementById('removeBackgroundBtn');
    if (removeBackgroundBtn) {
      removeBackgroundBtn.addEventListener('click', function() {
        if (!state.cloudinaryUrl) { showMessage('Please upload an image first', 'info'); return; }
        if (state.backgroundRemoved) { showMessage('Background already removed', 'info'); return; }
        showMessage('Removing background... This may take a few seconds.', 'info');
        var bgRemovedUrl;
        if (state.cloudinaryUrl.includes('/upload/v')) {
          bgRemovedUrl = state.cloudinaryUrl.replace('/upload/v', '/upload/e_background_removal,f_png/v');
        } else {
          bgRemovedUrl = state.cloudinaryUrl.replace('/upload/', '/upload/e_background_removal,f_png/');
        }
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() {
          state.uploadedImage     = img;
          state.uploadedImageUrl  = bgRemovedUrl;
          state.cloudinaryUrl     = bgRemovedUrl;
          state.backgroundRemoved = true;
          var maxSize = state.canvasSize * 0.85;
          state.imageScale    = maxSize / Math.max(img.width, img.height);
          state.imagePosition = { x: 225, y: 225 };
          showMessage('Background removed successfully!', 'success');
        };
        img.onerror = function() { showMessage('Background removal failed. Please try again.', 'error'); };
        img.src = bgRemovedUrl;
      });
    }
  }

  function setupPreviewCheckbox() {
    var cb = document.getElementById('requestPreviewCheckbox');
    if (cb) cb.addEventListener('change', function() { state.requestManualPreview = this.checked; });
  }

  // ============================================
  // HIT TESTING
  // ============================================

  function getResizeHandles() {
    if (!state.uploadedImage) return [];
    var sw = state.uploadedImage.width  * state.imageScale;
    var sh = state.uploadedImage.height * state.imageScale;
    var cx = state.imagePosition.x, cy = state.imagePosition.y;
    return [
      { x: cx-sw/2, y: cy-sh/2 }, { x: cx+sw/2, y: cy-sh/2 },
      { x: cx-sw/2, y: cy+sh/2 }, { x: cx+sw/2, y: cy+sh/2 },
      { x: cx, y: cy-sh/2 },      { x: cx, y: cy+sh/2 },
      { x: cx-sw/2, y: cy },      { x: cx+sw/2, y: cy }
    ];
  }

  function getDeleteButtonPosition() {
    if (!state.uploadedImage) return null;
    var sw = state.uploadedImage.width  * state.imageScale;
    var sh = state.uploadedImage.height * state.imageScale;
    return { x: state.imagePosition.x + sw/2, y: state.imagePosition.y - sh/2 };
  }

  function deleteSelectedElement() {
    if (!state.selectedElement) return;
    resetImageState();
    document.getElementById('uploadedImageInfo').style.display = 'none';
    var fi = document.getElementById('fileInput');
    if (fi) fi.value = '';
    showMessage('Image removed', 'success');
  }

  // ============================================
  // RENDER — PREVIEW
  // ============================================

  function renderCanvas() {
    var ctx    = state.ctx;
    var canvas = state.canvas;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Neutral gray background — same as regular die-cut
    ctx.fillStyle = '#909090';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (state.uploadedImage) {
      drawImageWithHoloBorderAndOverlay(ctx);
    }

    if (state.selectedElement) drawSelectionUI(ctx);
  }

  function buildImageCanvas() {
    var scaledWidth  = state.uploadedImage.width  * state.imageScale;
    var scaledHeight = state.uploadedImage.height * state.imageScale;

    var tempCanvas = document.createElement('canvas');
    tempCanvas.width  = state.canvas.width;
    tempCanvas.height = state.canvas.height;
    var tempCtx = tempCanvas.getContext('2d');

    tempCtx.save();
    tempCtx.translate(state.imagePosition.x, state.imagePosition.y);
    tempCtx.rotate((state.imageRotation * Math.PI) / 180);
    if (state.flipHorizontal) tempCtx.scale(-1, 1);
    if (state.flipVertical)   tempCtx.scale(1, -1);
    tempCtx.filter = 'brightness(' + state.brightness + '%) contrast(' + state.contrast + '%) saturate(' + state.saturation + '%)';
    tempCtx.drawImage(state.uploadedImage, -scaledWidth/2, -scaledHeight/2, scaledWidth, scaledHeight);
    tempCtx.restore();

    return tempCanvas;
  }

  function drawImageWithHoloBorderAndOverlay(ctx) {
    var tempCanvas = buildImageCanvas();

    // --- HOLOGRAPHIC BORDER ---
    var borderSize = 10;
    var steps = 20;
    var borderCanvas = document.createElement('canvas');
    borderCanvas.width  = state.canvas.width;
    borderCanvas.height = state.canvas.height;
    var borderCtx = borderCanvas.getContext('2d');

    // Offset the image in all directions to create a filled border shape
    for (var i = 0; i < steps; i++) {
      var angle = (i / steps) * Math.PI * 2;
      var dx = Math.round(Math.cos(angle) * borderSize);
      var dy = Math.round(Math.sin(angle) * borderSize);
      borderCtx.drawImage(tempCanvas, dx, dy);
    }

    // Make all non-transparent pixels of the border shape opaque white (as a mask)
    var borderImgData = borderCtx.getImageData(0, 0, borderCanvas.width, borderCanvas.height);
    var borderData = borderImgData.data;
    for (var b = 0; b < borderData.length; b += 4) {
      if (borderData[b + 3] > 10) {
        borderData[b] = 255; borderData[b+1] = 255; borderData[b+2] = 255; borderData[b+3] = 255;
      }
    }
    borderCtx.putImageData(borderImgData, 0, 0);

    // Clip the holographic pattern to the border mask shape
    var holoPattern = createHoloPattern(state.canvas.width, state.canvas.height);
    var borderMaskCanvas = document.createElement('canvas');
    borderMaskCanvas.width  = state.canvas.width;
    borderMaskCanvas.height = state.canvas.height;
    var borderMaskCtx = borderMaskCanvas.getContext('2d');
    borderMaskCtx.drawImage(borderCanvas, 0, 0);
    borderMaskCtx.globalCompositeOperation = 'source-in';
    borderMaskCtx.drawImage(holoPattern, 0, 0);

    // Draw border then image
    ctx.drawImage(borderMaskCanvas, 0, 0);
    ctx.drawImage(tempCanvas, 0, 0);

    // --- HOLOGRAPHIC OVERLAY ON LIGHT PIXELS ---
    applyHoloOverlayToLightPixels(ctx, tempCanvas);
  }

  function applyHoloOverlayToLightPixels(ctx, tempCanvas) {
    var w = state.canvas.width;
    var h = state.canvas.height;

    var imgData  = ctx.getImageData(0, 0, w, h);
    var pixels   = imgData.data;

    var holoPattern = createHoloPattern(w, h);
    var holoCtx = holoPattern.getContext('2d');
    var holoData = holoCtx.getImageData(0, 0, w, h).data;

    var tempCtx  = tempCanvas.getContext('2d');
    var tempData = tempCtx.getImageData(0, 0, w, h).data;

    for (var i = 0; i < pixels.length; i += 4) {
      // Only process pixels that have image content
      if (tempData[i + 3] < 20) continue;

      var r = tempData[i];
      var g = tempData[i + 1];
      var b = tempData[i + 2];

      // Lightness = average of max and min channels (0-255)
      var lightness = (Math.max(r, g, b) + Math.min(r, g, b)) / 2;

      // Blend amount: 0 at lightness 130, 0.75 at lightness 255
      if (lightness >= 130) {
        var blendAmount = ((lightness - 130) / 125) * 0.75;

        pixels[i]     = Math.round(pixels[i]     * (1 - blendAmount) + holoData[i]     * blendAmount);
        pixels[i + 1] = Math.round(pixels[i + 1] * (1 - blendAmount) + holoData[i + 1] * blendAmount);
        pixels[i + 2] = Math.round(pixels[i + 2] * (1 - blendAmount) + holoData[i + 2] * blendAmount);
      }
    }

    ctx.putImageData(imgData, 0, 0);
  }

  function drawSelectionUI(ctx) {
    if (!state.uploadedImage) return;
    ctx.save();
    ctx.strokeStyle = '#000DCA';
    ctx.lineWidth = 2;
    var sw = state.uploadedImage.width  * state.imageScale;
    var sh = state.uploadedImage.height * state.imageScale;
    ctx.strokeRect(state.imagePosition.x - sw/2, state.imagePosition.y - sh/2, sw, sh);

    getResizeHandles().forEach(function(h) {
      ctx.fillStyle = '#FFFFFF'; ctx.beginPath(); ctx.arc(h.x, h.y, 8, 0, Math.PI*2); ctx.fill();
      ctx.strokeStyle = '#000DCA'; ctx.stroke();
    });

    var del = getDeleteButtonPosition();
    if (del) {
      ctx.fillStyle = '#CF0000'; ctx.beginPath(); ctx.arc(del.x, del.y, 12, 0, Math.PI*2); ctx.fill();
      ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(del.x-5, del.y-5); ctx.lineTo(del.x+5, del.y+5);
      ctx.moveTo(del.x+5, del.y-5); ctx.lineTo(del.x-5, del.y+5);
      ctx.stroke();
    }
    ctx.restore();
  }

  // ============================================
  // HIGH-RES EXPORT — transparent PNG
  // ============================================

  function renderHighResCanvas(upscaledImage) {
    var ctx   = state.exportCtx;
    var scale = 4;
    ctx.clearRect(0, 0, 1800, 1800);

    if (state.uploadedImage) {
      var imgToDraw = upscaledImage || state.uploadedImage;
      var adjustedScale = state.imageScale;
      if (upscaledImage && state.uploadedImage) {
        adjustedScale = state.imageScale * (state.uploadedImage.width / upscaledImage.width);
      }
      ctx.save();
      ctx.translate(state.imagePosition.x * scale, state.imagePosition.y * scale);
      ctx.rotate((state.imageRotation * Math.PI) / 180);
      if (state.flipHorizontal) ctx.scale(-1, 1);
      if (state.flipVertical)   ctx.scale(1, -1);
      ctx.filter = 'brightness(' + state.brightness + '%) contrast(' + state.contrast + '%) saturate(' + state.saturation + '%)';
      var sw = imgToDraw.width  * adjustedScale * scale;
      var sh = imgToDraw.height * adjustedScale * scale;
      ctx.drawImage(imgToDraw, -sw/2, -sh/2, sw, sh);
      ctx.restore();
    }
  }

  // ============================================
  // SAVE
  // ============================================

  function setupSaveButton() {
    var saveBtn = document.getElementById('saveDesignBtn');
    if (!saveBtn) return;
    saveBtn.addEventListener('click', function() {
      if (!state.uploadedImage) { showMessage('Please upload an image before saving', 'error'); return; }
      state.selectedElement = null;
      showMessage('Generating high-resolution file...', 'info');

      if (state.cloudinaryUrl) {
        var upscaledUrl = state.cloudinaryUrl.replace('/upload/', '/upload/e_upscale,q_auto:best,f_png/');
        var upscaledImg = new Image();
        upscaledImg.crossOrigin = 'anonymous';
        upscaledImg.onload = function() {
          renderHighResCanvas(upscaledImg);
          state.exportCanvas.toBlob(function(blob) {
            if (!blob) { showMessage('Error generating design file', 'error'); return; }
            uploadHighResToCloudinary(blob);
          }, 'image/png', 1.0);
        };
        upscaledImg.onerror = function() {
          showMessage('Using original image quality', 'info');
          renderHighResCanvas();
          state.exportCanvas.toBlob(function(blob) {
            if (!blob) { showMessage('Error generating design file', 'error'); return; }
            uploadHighResToCloudinary(blob);
          }, 'image/png', 1.0);
        };
        upscaledImg.src = upscaledUrl;
      } else {
        renderHighResCanvas();
        state.exportCanvas.toBlob(function(blob) {
          if (!blob) { showMessage('Error generating design file', 'error'); return; }
          uploadHighResToCloudinary(blob);
        }, 'image/png', 1.0);
      }
    });
  }

  function uploadHighResToCloudinary(blob) {
    showMessage('Uploading print-ready file...', 'info');
    var formData = new FormData();
    formData.append('file', blob, 'holographic-diecut-design-highres.png');
    formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
    formData.append('folder', window.cloudinaryConfig.folder + '/print-ready');
    fetch('https://api.cloudinary.com/v1_1/' + window.cloudinaryConfig.cloudName + '/image/upload', {
      method: 'POST', body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.secure_url) uploadPreviewToCloudinary(data.secure_url);
      else showMessage('Upload failed. Please try again.', 'error');
    })
    .catch(function() { showMessage('Upload failed. Please try again.', 'error'); });
  }

  function uploadPreviewToCloudinary(highResUrl) {
    state.canvas.toBlob(function(previewBlob) {
      var formData = new FormData();
      formData.append('file', previewBlob, 'holographic-diecut-design-preview.jpg');
      formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
      formData.append('folder', window.cloudinaryConfig.folder + '/previews');
      fetch('https://api.cloudinary.com/v1_1/' + window.cloudinaryConfig.cloudName + '/image/upload', {
        method: 'POST', body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.secure_url) addToCartWithDesign(highResUrl, data.secure_url);
        else showMessage('Upload failed. Please try again.', 'error');
      })
      .catch(function() { showMessage('Upload failed. Please try again.', 'error'); });
    }, 'image/jpeg', 0.85);
  }

  function addToCartWithDesign(highResUrl, previewUrl) {
    if (!state.productData.variantId) tryToFindVariant();
    if (!state.productData.variantId) findVariantAndAddToCart(highResUrl, previewUrl);
    else addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
  }

  function findVariantAndAddToCart(highResUrl, previewUrl) {
    showMessage('Finding product variant...', 'info');
    var urlParams = new URLSearchParams(window.location.search);
    var returnUrl = urlParams.get('return_url') || document.referrer;
    var productHandle = 'die-cut-holographic-stickers';
    if (returnUrl) {
      var match = returnUrl.match(/\/products\/([^?\/]+)/);
      if (match && match[1]) productHandle = match[1];
    }
    fetch('/products/' + productHandle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      if (product.variants && product.variants.length > 0) {
        state.productData.variantId = product.variants[0].id;
        addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
      } else {
        showMessage('Could not find product variant. Please contact support.', 'error');
      }
    })
    .catch(function() { showMessage('Error finding product. Please go back and try again.', 'error'); });
  }

  function addToCartWithVariant(variantId, highResUrl, previewUrl) {
    var formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          'Custom Design': 'Yes - Holographic Die-Cut Design',
          'Sticker Type': 'Holographic Die-Cut',
          '_Design Preview': previewUrl,
          '_Print File': highResUrl,
          '_Design Specs': '1800x1800px transparent PNG',
          'Product Details': (state.productData.quantity || 'Custom') + ' \u2022 ' + (state.productData.size || 'Custom') + '"',
          '_Background Removed': state.backgroundRemoved ? 'Yes' : 'No',
          'Manual Preview Requested': state.requestManualPreview ? 'YES - Add 2-3 business days for preview approval' : 'No'
        }
      }]
    };
    showMessage('Adding design to cart...', 'info');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
    .then(function() {
      showMessage('Added to cart! Redirecting...', 'success');
      setTimeout(function() { window.location.href = '/cart'; }, 800);
    })
    .catch(function(err) { showMessage('Error adding to cart: ' + err.message, 'error'); });
  }

  // ============================================
  // RESET
  // ============================================

  function setupResetButton() {
    var resetBtn = document.getElementById('resetAllBtn');
    if (!resetBtn) return;
    resetBtn.addEventListener('click', function() {
      if (!confirm('Are you sure you want to reset your design? This cannot be undone.')) return;
      resetImageState();
      document.getElementById('uploadedImageInfo').style.display = 'none';
      var fi = document.getElementById('fileInput');
      if (fi) fi.value = '';
      resetAdjustmentSliders();
      var previewCheckbox = document.getElementById('requestPreviewCheckbox');
      if (previewCheckbox) previewCheckbox.checked = false;
      state.requestManualPreview = false;
      showMessage('Design reset successfully', 'success');
    });
  }

  function showMessage(message, type) {
    var existing = document.querySelector('.message-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'message-toast ' + type;
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.animation = 'slideOut 0.3s ease';
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  window.customizerState  = state;
  window.customizerRender = renderCanvas;

})();


// ============================================
// MOBILE — Toolbar and Panel Controls
// ============================================

(function() {
  'use strict';
  if (window.innerWidth > 768) return;

  var toolbarIcons = document.querySelectorAll('.mobile-toolbar-icon');
  var panels       = document.querySelectorAll('.mobile-slide-panel');
  var overlay      = document.querySelector('.mobile-panel-overlay');
  var closeButtons = document.querySelectorAll('.mobile-panel-close');
  var startY = 0, currentY = 0, isDragging = false, activePanel = null;

  toolbarIcons.forEach(function(icon) {
    icon.addEventListener('click', function() {
      var panelId = this.getAttribute('data-panel');
      var panel   = document.getElementById(panelId);
      panels.forEach(function(p) { p.classList.remove('active'); });
      toolbarIcons.forEach(function(i) { i.classList.remove('active'); });
      if (panel) {
        panel.classList.add('active');
        this.classList.add('active');
        overlay.classList.add('active');
        activePanel = panel;
      }
    });
  });

  closeButtons.forEach(function(btn) { btn.addEventListener('click', closeAllPanels); });
  if (overlay) overlay.addEventListener('click', closeAllPanels);

  panels.forEach(function(panel) {
    var panelHeader = panel.querySelector('.mobile-panel-header');
    panelHeader.addEventListener('touchstart', function(e) { startY = e.touches[0].clientY; isDragging = true; panel.style.transition = 'none'; });
    panelHeader.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      currentY = e.touches[0].clientY;
      var delta = currentY - startY;
      if (delta > 0) panel.style.transform = 'translateY(' + delta + 'px)';
    });
    panelHeader.addEventListener('touchend', function() {
      if (!isDragging) return;
      isDragging = false;
      panel.style.transition = 'transform 0.3s ease';
      if (currentY - startY > 100) closeAllPanels();
      else panel.style.transform = 'translateY(0)';
    });
  });

  function closeAllPanels() {
    panels.forEach(function(p) { p.style.transition = 'transform 0.3s ease'; p.style.transform = ''; p.classList.remove('active'); });
    toolbarIcons.forEach(function(i) { i.classList.remove('active'); });
    overlay.classList.remove('active');
    activePanel = null;
  }
})();


// ============================================
// MOBILE — Touch Interactions
// ============================================

(function() {
  'use strict';
  if (window.innerWidth > 768) return;

  setTimeout(function() {
    var mobileUploadArea = document.getElementById('mobileUploadArea');
    var mobileFileInput  = document.getElementById('mobileFileInput');
    if (mobileUploadArea && mobileFileInput) {
      mobileUploadArea.addEventListener('click', function() { mobileFileInput.click(); });
      mobileFileInput.addEventListener('change', function(e) {
        if (e.target.files && e.target.files[0]) {
          var desktopFileInput = document.getElementById('fileInput');
          if (desktopFileInput) {
            var dt = new DataTransfer();
            dt.items.add(e.target.files[0]);
            desktopFileInput.files = dt.files;
            desktopFileInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    var mobileCb  = document.getElementById('mobileRequestPreviewCheckbox');
    var desktopCb = document.getElementById('requestPreviewCheckbox');
    if (mobileCb && desktopCb) {
      mobileCb.addEventListener('change', function() {
        desktopCb.checked = this.checked;
        desktopCb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function setupMobileSlider(mobileId, desktopId, valueId) {
      var ms = document.getElementById(mobileId);
      var ds = document.getElementById(desktopId);
      var vd = document.getElementById(valueId);
      if (ms && ds) {
        ms.addEventListener('input', function() {
          ds.value = this.value;
          ds.dispatchEvent(new Event('input', { bubbles: true }));
          if (vd) {
            setTimeout(function() {
              var key = valueId.replace('mobile', '').charAt(0).toLowerCase() + valueId.replace('mobile', '').slice(1);
              var dv = document.getElementById(key);
              if (dv) vd.textContent = dv.textContent;
            }, 50);
          }
        });
      }
    }

    setupMobileSlider('mobileBrightnessSlider', 'brightnessSlider', 'mobileBrightnessValue');
    setupMobileSlider('mobileContrastSlider',   'contrastSlider',   'mobileContrastValue');
    setupMobileSlider('mobileSaturationSlider', 'saturationSlider', 'mobileSaturationValue');

  }, 1000);
})();


// ============================================
// MOBILE — Pinch-to-Resize and Tap-to-Select
// ============================================

(function() {
  'use strict';
  if (window.innerWidth > 768) return;

  setTimeout(function() {
    var canvas = document.getElementById('designCanvas');
    if (!canvas) return;

    var pinchState = { active: false, startDistance: 0, initialSize: 0 };
    var firstTouchPos = null, firstTouchTime = 0, isDraggingMobile = false;
    var dragOffset = { x: 0, y: 0 };

    function getTouchPos(touch) {
      var rect   = canvas.getBoundingClientRect();
      var scaleX = canvas.width  / rect.width;
      var scaleY = canvas.height / rect.height;
      return { x: (touch.clientX - rect.left) * scaleX, y: (touch.clientY - rect.top) * scaleY };
    }

    function getDistance(t1, t2) {
      var p1 = getTouchPos(t1), p2 = getTouchPos(t2);
      return Math.sqrt(Math.pow(p2.x-p1.x, 2) + Math.pow(p2.y-p1.y, 2));
    }

    canvas.addEventListener('touchstart', function(e) {
      var state = window.customizerState;
      if (!state) return;
      if (e.touches.length === 1) {
        firstTouchPos  = getTouchPos(e.touches[0]);
        firstTouchTime = Date.now();
        isDraggingMobile = false;
        if (state.selectedElement && state.uploadedImage) {
          dragOffset.x = firstTouchPos.x - state.imagePosition.x;
          dragOffset.y = firstTouchPos.y - state.imagePosition.y;
          e.preventDefault(); e.stopPropagation();
        }
        return;
      }
      if (e.touches.length === 2 && state.uploadedImage) {
        e.preventDefault(); e.stopPropagation();
        firstTouchPos = null; firstTouchTime = 0; isDraggingMobile = false;
        pinchState.active = true;
        pinchState.startDistance = getDistance(e.touches[0], e.touches[1]);
        pinchState.initialSize = state.imageScale;
      }
    }, true);

    canvas.addEventListener('touchmove', function(e) {
      var state = window.customizerState;
      if (!state) return;
      if (e.touches.length === 2 && pinchState.active) {
        e.preventDefault(); e.stopPropagation();
        var ratio = getDistance(e.touches[0], e.touches[1]) / pinchState.startDistance;
        state.imageScale = Math.max(0.1, Math.min(5, pinchState.initialSize * ratio));
        return;
      }
      if (e.touches.length === 1 && firstTouchPos && state.selectedElement && state.uploadedImage) {
        var currentPos = getTouchPos(e.touches[0]);
        var dist = Math.sqrt(Math.pow(currentPos.x-firstTouchPos.x, 2) + Math.pow(currentPos.y-firstTouchPos.y, 2));
        if (dist > 10) {
          e.preventDefault(); e.stopPropagation();
          isDraggingMobile = true;
          state.imagePosition.x = currentPos.x - dragOffset.x;
          state.imagePosition.y = currentPos.y - dragOffset.y;
        }
      }
    }, true);

    canvas.addEventListener('touchend', function(e) {
      var state = window.customizerState;
      if (!state) return;
      if (pinchState.active) { e.preventDefault(); e.stopPropagation(); pinchState.active = false; }
      if (e.touches.length === 0 && firstTouchPos !== null && !isDraggingMobile) {
        var tapDuration = Date.now() - firstTouchTime;
        if (tapDuration < 300 && state.uploadedImage) {
          var sw = state.uploadedImage.width  * state.imageScale;
          var sh = state.uploadedImage.height * state.imageScale;
          if (firstTouchPos.x >= state.imagePosition.x - sw/2 && firstTouchPos.x <= state.imagePosition.x + sw/2 &&
              firstTouchPos.y >= state.imagePosition.y - sh/2 && firstTouchPos.y <= state.imagePosition.y + sh/2) {
            state.selectedElement = { type: 'image', index: 0 };
          } else {
            state.selectedElement = null;
          }
        }
      }
      firstTouchPos = null; firstTouchTime = 0; isDraggingMobile = false;
    }, true);

  }, 1500);

  var deleteBtn = document.getElementById('mobileFloatingDelete');
  if (deleteBtn) {
    setInterval(function() {
      var state = window.customizerState;
      deleteBtn.style.display = (state && state.selectedElement) ? 'block' : 'none';
    }, 200);
    deleteBtn.addEventListener('click', function() {
      var state = window.customizerState;
      if (!state || !state.selectedElement) return;
      var db = document.getElementById('removeImageBtn');
      if (db) db.click();
      state.selectedElement = null;
    });
  }
})();